

















import Vue from 'vue';
import AppFooter from '@/components/layout/AppFooter.vue';
import AppDrawerHeader from '@/components/layout/AppDrawer/AppDrawerHeader.vue';
import { mapActions, mapState } from 'vuex';

export default Vue.extend({
  name: 'AppDrawer',
  components: {
    AppFooter,
    AppDrawerHeader,
  },
  computed: {
    ...mapState('global', ['showDrawer']),
    drawerState: {
      get(): boolean {
        return this.showDrawer;
      },

      set(value) {
        this.toggleDrawer(value);
      },
    },
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('global', ['toggleDrawer']),
    logoutUser(): void {
      this.logout().then(() => {
        this.toggleDrawer(false);
        this.$store.commit('RESET_STATE');
        this.$router.push('/login');
      });
    },
  },
});
